import {
    action,
} from './common';

export const NEWSLETTER_STEPPER_STEP = 'NEWSLETTER_STEPPER_STEP';
export const newsLetterActiveStep = payload => action(NEWSLETTER_STEPPER_STEP, {  payload});